import { IVmNetworkDto } from 'store/network/types/api-bodies.types';
import { NetworkStatus } from 'store/network/types/enum';
import { INetwork, NetworkLinkedEntity } from 'store/network/types/network';
import { IVMDtoUnsync } from 'store/virtual-machine/types/api-bodies.types';

class VMNetwork implements INetwork {
  id: number;

  name: string | null;

  ip: string | null;

  mask: string | null;

  local: boolean;

  status?: NetworkStatus;

  linkedVms: IVMDtoUnsync[] = [];

  address: string | null = null;

  mac: string | null = null;

  k8SClusterIds: Record<number, string> = {};

  loadBalancerIds: Record<number, string> = {};

  linkedAsgsIds: Record<number, string> = {};

  gateway: string | null;

  firewallGroup: Array<{
    name: string,
    id: number
    projectId: number
  }> = [];

  projectId: number = -1;

  linkedClusters: NetworkLinkedEntity[] = [];

  linkedLoadbalancers: NetworkLinkedEntity[] = [];

  linkedAsgs: NetworkLinkedEntity[] = [];

  userNetId: number;

  constructor(dto: IVmNetworkDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.ip = dto.ip;
    this.mask = dto.mask;
    this.local = dto.local;
    this.mac = dto.mac || null;
    this.gateway = dto.gw;
    this.userNetId = dto.userNetId;
  }
}

export default VMNetwork;
